import React from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { Button } from "@/components/ui/button";
import { CourseDetailsFields } from "@/modules/learningCenter/features/CourseManagement/components/CourseDetailsFields/CourseDetailsFields";
import { useCreateCourse } from "@/modules/learningCenter/features/CourseManagement/hooks/useCreateCourse/useCreateCourse";

/**
 * Create Course screen — course details ONLY. There is no module management
 * here; on save the user is redirected to the Edit screen, where modules are
 * added (publishing requires at least one module).
 */
const CreateCourse: React.FC = () => {
  const {
    form,
    metadata,
    metadataLoading,
    isSubmitting,
    submitForm,
    handleCancel,
  } = useCreateCourse();

  return (
    <MainPageWrapper
      loading={metadataLoading}
      subtitle="Enter the course details. You'll add modules on the next screen."
      title="Create Course"
    >
      <CourseDetailsFields form={form} metadata={metadata} />

      <div className="mt-6 flex justify-end gap-2">
        <Button onClick={handleCancel} type="button" variant="outline">
          Cancel
        </Button>
        <Button disabled={isSubmitting} onClick={submitForm} type="button">
          Create Course
        </Button>
      </div>
    </MainPageWrapper>
  );
};

export default CreateCourse;
